export default "__VITE_ASSET__21c01d72__"